import { AppHelper } from "../appHelper"
import { AppBaseProps, CommonApp, Context, Entity } from "../core/components/commonApp";
import { MetaDataHelper } from "../core/util/metaDataHelper";
import { NotificationHelper } from "../core/util/notificationHelper";
import { HTTPService } from "../core/util/httpManager";
import { SheetEventType, Sheet } from "../../siteManagement/sheet";
import { General } from "../../siteManagement/general";
import { DialogHelper } from "../core/util/dialogHelper";
import ServerTemplateExecuteApp from "../serverTemplate/serverTemplateExecute";
import { Config } from "../core/config/config";
import { Helper } from "../core/util/helper";
import { ComponentHelper } from "../core/util/componentHelper";
import { TextBox } from "../core/components/textBox";
import { FieldInstance } from "../core/components/field";
import React from "react";

export default class GeneralSettingsApp extends React.Component<GeneralSettingsAppProps, any> {
    private factory = ComponentHelper.createFactory();
    common = new AppHelper();
    noBookmark = true;
    setTabTitle = true;
    translations = [];
    editTicketTypesGridOptions = [];
    editTicketStatusGridOptions = [];
    editTicketInternalStatusGridOptions = [];
    editTicketMediumGridOptions = [];
    faultCodesGridOptions = [];
    editGroupGridOptions = [];
    editIdentifierGridOptions = [];
    editSpecialCalendarGridOptions = [];
    editTicketUrgencyGridOptions = [];
    editStandardCalendarGridOptions = [];
    editMaschineGroupGridOptions = [];
    editMaschineMainGroupGridOptions = [];
    editMaschineTypesGridOptions = [];
    editMaschineStatusGridOptions = [];
    languagesManagementGridOptions = [];
    adrTypesGridOptions = [];
    vATRateGridOptions = [];
    documentCategoriesGridOptions = [];
    subDocumentCategoriesGridOptions = [];
    resourceTypesGridOptions = [];
    succursalesGridOptions = [];
    vehicleGridOptions = [];
    productGroupGridOptions = [];
    projectStatusGridOptions = [];
    projectTypeGridOptions = [];
    currencyGridOptions = [];
    internalCurrencyGridOptions = [];
    freeOfChargeKeyGridOptions = [];
    quanosCatalogGridOptions = [];
    cashExpenseGridOptions = [];
    shippingMethodsGridOptions = [];
    cSSVariablesGridOptions = [];
    pushNotificationStateGridOptions = [];
    showClearCacheButton = false;
    private sheet: Sheet = null;
    private isDirty: boolean = false;
    constructor(props: GeneralSettingsAppProps) {
        super(props);
        this.common.init(this);
        this.sheet = General.Sheet.Manager.getTopMostSheet();
        this.props.context.translations = this.translations;
        this.props.context.editTicketTypesGridOptions = this.editTicketTypesGridOptions;
        this.props.context.editTicketStatusGridOptions = this.editTicketStatusGridOptions;
        this.props.context.editTicketInternalStatusGridOptions = this.editTicketInternalStatusGridOptions;
        this.props.context.editTicketMediumGridOptions = this.editTicketMediumGridOptions;
        this.props.context.faultCodesGridOptions = this.faultCodesGridOptions;
        this.props.context.editGroupGridOptions = this.editGroupGridOptions;
        this.props.context.editIdentifierGridOptions = this.editIdentifierGridOptions;
        this.props.context.editSpecialCalendarGridOptions = this.editSpecialCalendarGridOptions;
        this.props.context.editTicketUrgencyGridOptions = this.editTicketUrgencyGridOptions;
        this.props.context.editStandardCalendarGridOptions = this.editStandardCalendarGridOptions;
        this.props.context.editMaschineGroupGridOptions = this.editMaschineGroupGridOptions;
        this.props.context.editMaschineMainGroupGridOptions = this.editMaschineMainGroupGridOptions;
        this.props.context.editMaschineTypesGridOptions = this.editMaschineTypesGridOptions;
        this.props.context.editMaschineStatusGridOptions = this.editMaschineStatusGridOptions;
        this.props.context.languagesManagementGridOptions = this.languagesManagementGridOptions;
        this.props.context.adrTypesGridOptions = this.adrTypesGridOptions;
        this.props.context.vATRateGridOptions = this.vATRateGridOptions;
        this.props.context.documentCategoriesGridOptions = this.documentCategoriesGridOptions;
        this.props.context.subDocumentCategoriesGridOptions = this.subDocumentCategoriesGridOptions;
        this.props.context.resourceTypesGridOptions = this.resourceTypesGridOptions;
        this.props.context.succursalesGridOptions = this.succursalesGridOptions;
        this.props.context.vehicleGridOptions = this.vehicleGridOptions;
        this.props.context.productGroupGridOptions = this.productGroupGridOptions;
        this.props.context.projectStatusGridOptions = this.projectStatusGridOptions;
        this.props.context.projectTypeGridOptions = this.projectTypeGridOptions;
        this.props.context.currencyGridOptions = this.currencyGridOptions;
        this.props.context.internalCurrencyGridOptions = this.internalCurrencyGridOptions;
        this.props.context.freeOfChargeKeyGridOptions = this.freeOfChargeKeyGridOptions;
        this.props.context.cashExpenseGridOptions = this.cashExpenseGridOptions;
        this.props.context.shippingMethodsGridOptions = this.shippingMethodsGridOptions;
        this.props.context.cSSVariablesGridOptions = this.cSSVariablesGridOptions;
        this.props.context.pushNotificationStateGridOptions = this.pushNotificationStateGridOptions;
        this.props.context.quanosCatalogGridOptions = this.quanosCatalogGridOptions;
        this.handleFieldChange({ model: "entity.GeneralSettings.ProtokollAktivieren" }, this.props.entity.GeneralSettings.ProtokollAktivieren, null, true);
        this._setEvents();

    }


    private validate = async () => {
        if (!this.common.validate()) {
            return false;
        }
        if (!Helper.isNullOrEmpty(this.props.entity.NukreisSettings.AssignmentAbsenceNukreis) && this.props.entity.NukreisSettings.AssignmentAbsenceNukreis == this.props.entity.NukreisSettings.AssignmentAddressrelatedNukreis) {
            return await DialogHelper.confirm(Helper.getTranslation("WebCRM.Nukreis.SameKey"))
        }
        return true;
    }

    save = async (closeAfterSave: boolean) => {
        const isOk = await this.validate();
        if (isOk) {
            if (this.isDirty) {
                this.sheet.trigger(SheetEventType.Custom, { command: "saveVariables" });
            }
            const result = await HTTPService.post("GeneralSettings/Save", this.props.entity);
            if (result.Code === 0) {
                this.props.entity.IsNew = false;
                //NotificationHelper.showSuccessMessage(result.Message);
                if (!this.isDirty) {
                    this.isDirty = false;
                    setTimeout(() => {
                        document.getElementById('logout-form__trigger').click();
                    }, 1000);
                }
            }
            else if (result.Code == 1) {
                NotificationHelper.showErrorMessage(result.Message);
            }
            else if (result.Code == 2) {
                NotificationHelper.showWarningMessage(result.Message);
            }
            this.common.handlePostSave(result.Code === 0, closeAfterSave);
        }
    }

    private _setEvents = () => {
        this.sheet.bind(SheetEventType.Custom, (cus: { command: string, value: any }) => {
            switch (cus.command) {
                case ("setGeneralSettingsStateDirty"):
                    this.isDirty = true;
                    this.common.setEntityDirtyState(true);
                    break;
                case "activateClearCacheButton":
                    this.showClearCacheButton = cus.value;
                    this.setState({});
                    break;
            }
        });
    }

    handleFieldChange = (field: any, value: any, dataItem = null, isInit = false) => {

        //if ((field.model == "entity.GeneralSettings.ProtokollAktivieren")) {
        //    MetaDataHelper.setReadOnly(this.props.metadata, "entity.GeneralSettings.ProjektProtokollAktivieren", !value);
        //    MetaDataHelper.setReadOnly(this.props.metadata, "entity.GeneralSettings.EinsatzProtokollAktivieren", !value);
        //    MetaDataHelper.setReadOnly(this.props.metadata, "entity.GeneralSettings.AdresseProtokollAktivieren", !value);
        //    MetaDataHelper.setReadOnly(this.props.metadata, "entity.GeneralSettings.MaschineProtokollAktivieren", !value);
        //    MetaDataHelper.setReadOnly(this.props.metadata, "entity.GeneralSettings.VorgangProtokollAktivieren", !value);
        //    MetaDataHelper.setReadOnly(this.props.metadata, "entity.GeneralSettings.RessourceProtokollAktivieren", !value);
        //}
        switch (field.model) {
            case "entity.GeneralSettings.ProtokollAktivieren":
                MetaDataHelper.setReadOnly(this.props.metadata, "entity.GeneralSettings.ProjektProtokollAktivieren", !value);
                MetaDataHelper.setReadOnly(this.props.metadata, "entity.GeneralSettings.EinsatzProtokollAktivieren", !value);
                MetaDataHelper.setReadOnly(this.props.metadata, "entity.GeneralSettings.AdresseProtokollAktivieren", !value);
                MetaDataHelper.setReadOnly(this.props.metadata, "entity.GeneralSettings.MaschineProtokollAktivieren", !value);
                MetaDataHelper.setReadOnly(this.props.metadata, "entity.GeneralSettings.VorgangProtokollAktivieren", !value);
                MetaDataHelper.setReadOnly(this.props.metadata, "entity.GeneralSettings.RessourceProtokollAktivieren", !value);
                MetaDataHelper.setReadOnly(this.props.metadata, "entity.GeneralSettings.AnsprechpartnerProtokollAktivieren", !value);
                break;
            case "entity.GeneralSettings.ObergruppenRechteInSuche":
                const ask = async () => {
                    const isOk = await DialogHelper.confirm(this.translations["WebSMS.GeneralSettings.AskForChange"]);
                    if (isOk) {
                        this.common.handleFieldChange(field, value, dataItem);
                    } else {
                        this.common.handleFieldChange(field, !value, dataItem);
                    }
                }
                //isInit = true;
                ask().then();
                break;
        }

        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);
    }

    executeServerTemplate = async () => {
        const sheet = General.Sheet.Manager.createSheet();
        let url = 'ServerTemplate/InitExecuteTemplate?Ressnr=&Templateid=2&RessourceTyp=4';
        const results = await Promise.all([
            HTTPService.get(url),
            Helper.getMetaData("serverTemplateExecute")
        ]);

        sheet.show(() => {
            const servertemplateexecutevm = results[0].Data;
            const metadata = results[1];
            const props = {
                title: "",
                entity: servertemplateexecutevm,
                context: { contextType: "serverTemplateExecute", translations: null },
                metadata: metadata,
                executeTemplate: true,
                doNotUpdateBrowserTitle: false
            } as any;
            sheet.mountContent(ServerTemplateExecuteApp, props);
        });
    }

    clearCache = () => {
        window.location.href = Config.baseUrl + "GeneralSettings/Edit";
    }
    
    htmlOrTextEditor = () => {
        const props = this.factory.getDefaultTextBoxProps();
        props.field.readOnly = !this.props.entity.UpdateWarning.Active;
        props.value = this.props.entity.UpdateWarning.HtmlOrText;
        props.field.triggerOnChange = true;
        props.field.model = "entity.UpdateWarning.HtmlOrText";
        props.field.multiLine = true;
        props.disabled = false;
        props.field.sanitizeHtml = true;
        props.textAreaHeight = '100px';
        props.onChange = this.handleFieldChange;
        return (<TextBox {...props} />);
    }
    
    
    htmlPreview = () => {
        const header = document.getElementById("header");
        const color = header?.style?.color || "white";
        const html = Helper.sanitizeHtml(this.props.entity.UpdateWarning.HtmlOrText);
        const htmlViewer =  (
            <div 
                style={{
                    border: '1px solid #ccc',
                    padding: '20px',
                    borderRadius: '8px',
                    maxHeight: '200px',
                    overflowY: 'auto',
                    backgroundColor: 'var(--primary-color)',
                    color: color
                }}
                dangerouslySetInnerHTML={{ __html: html }}
            />)
        
        return (<FieldInstance noHover={true} noLabel={true}>
            {htmlViewer}
        </FieldInstance>)
        
        
        
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { apphelper: this.common, handleFieldChange: this.handleFieldChange });
        return <CommonApp {...props} />;
    }
};

export interface GeneralSettingsAppProps extends AppBaseProps {
    entity: GeneralSettingsEntity;
    context: ContextGeneralSettingsApp;
}

export interface GeneralSettingsEntity extends Entity {
    GeneralSettings: {
        ProtokollAktivieren: boolean;
        LocationIQApiKey: string;
        GoogleGeocodeApiKey: string;
    },
    NukreisSettings: any,
    UpdateTranslationViews: boolean;
    UpdateWarning: any;
}

export interface ContextGeneralSettingsApp extends Context {
    editTicketTypesGridOptions?: any;
    editTicketStatusGridOptions?: any;
    editTicketInternalStatusGridOptions?: any;
    faultCodesGridOptions?: any;
    editGroupGridOptions?: any;
    editIdentifierGridOptions?: any;
    editSpecialCalendarGridOptions?: any;
    editTicketUrgencyGridOptions?: any;
    editTicketMediumGridOptions?: any;
    editStandardCalendarGridOptions?: any;
    editMaschineGroupGridOptions?: any;
    editMaschineMainGroupGridOptions?: any;
    editMaschineTypesGridOptions?: any;
    editMaschineStatusGridOptions?: any;
    languagesManagementGridOptions?: any;
    adrTypesGridOptions?: any;
    vATRateGridOptions?: any;
    documentCategoriesGridOptions?: any;
    subDocumentCategoriesGridOptions?: any;
    resourceTypesGridOptions?: any;
    succursalesGridOptions?: any;
    vehicleGridOptions?: any;
    productGroupGridOptions?: any;
    nachschlagGridOptions?: any;
    projectStatusGridOptions?: any;
    projectTypeGridOptions?: any;
    currencyGridOptions?: any;
    internalCurrencyGridOptions?: any;
    freeOfChargeKeyGridOptions?: any;
    cashExpenseGridOptions?: any;
    shippingMethodsGridOptions?: any;
    cSSVariablesGridOptions?: any;
    pushNotificationStateGridOptions?: any;
    translations?: Array<string>;
    quanosCatalogGridOptions?: any;
}